import {Marked} from 'marked'
import TurndownService from 'turndown'

function supTokenizer(src){
  // Regex to match ^Number^
  const rule = /^\^([^\\^]+)\^/ 
  const match = rule.exec(src)
  if (match) {
    return {
      type: 'sup', 
      raw: match[0],
      text: match[1].trim() 
    }
  }
  return false
}


const to_html_rules = {
  breaks: true, 
  gfm: true,
  renderer: {
    link(href, title, text) {
      if (href.startsWith('file://') ) {
        return `<a href="${href}" spellcheck="false" class="file">${text}</a>`
      }
      return `<a href="${href}" spellcheck="false" target="_blank">${text}</a>`
    },
    strong(text) {
      return `<b>${text}</b>`
    },
    em(text) {
      return `<i>${text}</i>`
    }
  },
  walkTokens(token) {
    if (token.type === 'link') {
      // If gfm: true, URLs are parsing by regexp for the link tag.
      // If there is [^...^](http://...) nearby, they are merged.
      // in this case we split them out and create link-container
      const regexp = /(\[\^[^[\]^]+\^\]\([^)]+\))/g
      const parts = token.text.split(regexp).filter(p => !!p.trim())
      if (parts?.length > 1) {
        const tokens = parts.flatMap(p => this.Lexer.lexInline(p))
        tokens.forEach(t => {
          if (!t.tokens) return
          t.tokens = t.tokens.flatMap(x => x.text ? supTokenizer(x.text) || x : x)
        })
        token.tokens = tokens
        token.type = 'link-container'
      }
    }
  },
  extensions: [
    {
      name: 'sup',
      level: 'inline',
      start(src) {
        return src.match(/\^/)?.index
      },
      tokenizer: supTokenizer,
      renderer(token) {
        return `<sup>${token.text}</sup>`
      }
    },
    {
      name: 'link-container',
      level: 'inline',
      renderer(token) {
        return this.parser.parseInline(token.tokens)
      }
    },
    {
      name: 'button',
      level: 'inline',
      start(src) {
        const regex = /\[.*?\]\(button.*?\)/
        return src.match(regex)?.index
      },
      tokenizer(src) {
        const regex = /\[(.*?)\]\(button type='(.*?)' click=(\d+)\)/
        const match = src.match(regex)
        if (match) {
          return {
            type: 'button',
            raw: match[0],
            b_text: match[1],
            b_type: match[2],            
            b_click: parseInt(match[3], 10)
          }
        }
        return undefined
      },
      renderer(token) {
        return `<button type='${token.b_type}' click=${token.b_click}>${token.b_text}</b>`
      }
    }
  ],
}


const to_md_rules = [
  {
    name: 'sup',
    filter: 'sup',
    replacement: function (content) {
      return '^' + content + '^'
    }
  }
]

export default class Markdown {
  constructor() {
    this.marked = new Marked()
    this.marked.use(to_html_rules)

    this.turndown = new TurndownService()
    to_md_rules.forEach(rule => this.turndown.addRule(rule.name, rule))
  }
  makeHTML(text) {
    // Fix sources with exclamation sign to be not converted to image
    if (typeof text === 'string') {
      const fixedText = text
        .replaceAll('![', '\\![')
        .replaceAll(/\u202F/g, ' ') // TEMPORARY: remove after Jan 1 2026
      return this.marked.parse(fixedText)
    }
    console.log('WARNING: text passed to makeHTML is not a string')
    return ''
  }
  makeMD(text) {
    return this.turndown.turndown(text)
  }
}
